module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', [_c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Total faktureret ift. tidstracking")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.byUsers), function(user, user_i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": user
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_vm._v(_vm._s(user.first_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm.outputMoney(user.billable_kr)) + " kr.")]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(user.billable_pct) + " %")])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "align-r"
  }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.allBudgetsTotal)) + " kr.")])]), _vm._v(" "), _c('td')])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Udregning")])]), _c('p', [_vm._v("Brugerens projekter gennemgås. For hvert projekt aflæses brugerens andel af tid logget på projektet. Denne andel holdes op imod projektets samlede budget.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Husk, at denne udregning kun tager højde for hvor mange timer brugerne har tracket, og ikke medberegner graden af effektivitet per time.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-132f2e0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Report_invoicability.vue
// module id = 581
// module chunks = 1